import React from "react";
import { useContent } from "@/contexts/ContentContext";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import Portfolio from "@/components/landing/Portfolio";
import About from "@/components/landing/About";
import Testimonials from "@/components/landing/Testimonials";
import QuoteForm from "@/components/landing/QuoteForm";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

export default function Landing() {
    const { content, services, gallery, testimonials, loading } = useContent();

    if (loading || !content) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black text-yellow-400 font-mono-accent text-xs tracking-widest">
                LOADING RUIZ CONCRETE…
            </div>
        );
    }

    const { hero, business, contact } = content;

    return (
        <main className="bg-[#050505] min-h-screen relative" data-testid="landing-page">
            <Nav logoUrl={hero.logo_url} phone={contact.phone} />
            <Hero hero={hero} contact={contact} />
            <Services services={services} />
            <Portfolio gallery={gallery} />
            <About business={business} contact={contact} />
            <Testimonials items={testimonials} />
            <QuoteForm contact={contact} services={services} />
            <Footer business={business} contact={contact} logoUrl={hero.logo_url} />
            <WhatsAppButton />
        </main>
    );
}
